import React from "react";
import { useNavigate } from "react-router-dom";
import "./index.css";
import { getCarName } from "../../../helpers/carName";

export default function CarCard({
  id,
  key,
  img,
  similarTo,
  noOfPeople,
  noOfBags,
  dailyRate,
  totalCost,
  cardPath,
  fromDate,
  fromTime,
  untilDate,
  untilTime,
  bookingPeriod,
  unavailable,
  availabilityBucket,
  car,
  driveTrain,
  deliveryCharge = null,
}) {
  const navigate = useNavigate();

  const handleMoveInfoPage = () => {
    navigate(cardPath);
  };

  const handleNextCarDetailPage = (e) => {
    e.preventDefault();
    handleMoveInfoPage();
  };

  const minimumDuration = car?.trip_preference?.min_trip_duration;
  const isFeatured = Boolean(car?.is_featured);
  const tripLength = bookingPeriod && bookingPeriod > 0 ? bookingPeriod : 1;
  const dailyRateNumber = Number(dailyRate || 0);
  const totalCostNumber =
    totalCost !== null && totalCost !== undefined && Number(totalCost) > 0
      ? Number(totalCost)
      : dailyRateNumber * tripLength;
  const discountAmount = Number(car?.discount || 0);
  const deliveryChargeAmount =
    deliveryCharge && bookingPeriod < 7 ? Number(deliveryCharge) : 0;
  const carCurrentPrice = dailyRateNumber.toFixed(2);
  const carCheckoutPrice = (
    totalCostNumber +
    deliveryChargeAmount -
    discountAmount
  ).toFixed(2);
  const meetsMinimumDuration =
    minimumDuration == null || !bookingPeriod
      ? true
      : bookingPeriod >= minimumDuration;

  const resolvedAvailabilityBucket =
    availabilityBucket ??
    (!meetsMinimumDuration ? 1 : unavailable ? 2 : 0);

  const isUnavailableForSearch = resolvedAvailabilityBucket === 2;
  const needsDifferentDates = resolvedAvailabilityBucket === 1;

  return (
    <div
      key={key}
      className="carCard_wrapper"
      onClick={(e) => handleNextCarDetailPage(e)}
    >
      <div className="carCard_hero_img">
        <img src={img} alt="car_1" />
        {isUnavailableForSearch ? (
          <div className="unavailableMark">Unavailable</div>
        ) : needsDifferentDates ? (
          <div className="unavailableMark">{`${minimumDuration} Day Minimum`}</div>
        ) : (
          ""
        )}
      </div>
      <div className="carCard_body">
        {isFeatured && (
          <div className="carCard_badges">
            <span className="carCard_badge">Featured</span>
          </div>
        )}
        <div className="carCard_title">{getCarName(car)}</div>
        <div className="car_details">
          <div className="car_similar_to">{similarTo}</div>
          <div style={{ display: "none" }} className="price_details">
            Features & Price Details
            <svg
              width="8"
              viewBox="0 0 8 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M-8.74228e-08 12L5 7L-5.24537e-07 2L0.999999 -4.37114e-08L8 7L1 14L-8.74228e-08 12Z"
                fill="#4FC8E9"
              />
            </svg>
          </div>
        </div>
        <div className="car_tags">
          <span>
            <img src="/assets/imgs/automatic.png" alt="" />
            {driveTrain}
          </span>
          <span>
            <img src="/assets/imgs/car.png" alt="" />
            {noOfPeople}
          </span>
          <span>
            <img src="/assets/imgs/people.png" alt="" />
            {noOfBags} Passengers
          </span>
        </div>

        <div className="car_costs">
          <div className="daily_rate">Daily Rate: $ {carCurrentPrice}</div>
          <div className="total_cost">Total Cost: $ {carCheckoutPrice}</div>
        </div>

        <div className="car_select_btn">
          {isUnavailableForSearch ? (
            <button className="unavailable">Unavailable</button>
          ) : needsDifferentDates ? (
            <button className="unavailable">Check Available Dates</button>
          ) : (
            <button className="select_btn" type="submit">
              Select
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
